export const SET_DETAIL_SETTINGS_ERROR = 'settings/SET_DETAIL_SETTINGS_ERROR';
export const UPDATE_DETAIL_SETTINGS = 'settings/UPDATE_DETAIL_SETTINGS';
export const UPDATE_DETAIL_SETTINGS_ERROR = 'settings/UPDATE_DETAIL_SETTINGS_ERROR';
export const GET_APPLICATION_SETTINGS_DATA = 'settings/GET_APPLICATION_SETTINGS_DATA';
export const GET_APPLICATION_SETTINGS_DATA_SUCCESS = 'settings/GET_APPLICATION_SETTINGS_DATA_SUCCESS';
export const GET_APPLICATION_SETTINGS_DATA_ERROR = 'settings/GET_APPLICATION_SETTINGS_DATA_ERROR';

// ACCESS
export const FETCH_USERS_ACCESS = 'settings/FETCH_USERS_ACCESS';
export const FETCH_USERS_ACCESS_SUCCESS = 'settings/FETCH_USERS_ACCESS_SUCCESS';
export const FETCH_USERS_ACCESS_ERROR = 'settings/FETCH_USERS_ACCESS_ERROR';
export const ACCESS_INVITE_USERS = 'settings/ACCESS_INVITE_USERS';
export const ACCESS_INVITE_USERS_ERROR = 'settings/ACCESS_INVITE_USERS_ERROR';

// LANGUAGE
export const FETCH_LANGUAGE_LIST = 'settings/FETCH_LANGUAGE_LIST';
export const FETCH_LANGUAGE_LIST_SUCCESS = 'settings/FETCH_LANGUAGE_LIST_SUCCESS';
export const FETCH_LANGUAGE_LIST_ERROR = 'settings/FETCH_LANGUAGE_LIST_ERROR';

// TRANSLATIONS
export const EXPORT_TRANSLATIONS = 'settings/EXPORT_TRANSLATIONS';
export const EXPORT_TRANSLATIONS_ERROR = 'settings/EXPORT_TRANSLATIONS_ERROR';
export const IMPORT_TRANSLATIONS = 'settings/IMPORT_TRANSLATIONS';
export const IMPORT_TRANSLATIONS_ERROR = 'settings/IMPORT_TRANSLATIONS_ERROR';
export const EXPORT_ADD_ON_TRANSLATIONS = 'settings/EXPORT_ADD_ON_TRANSLATIONS';
export const EXPORT_ADD_ON_TRANSLATIONS_ERROR = 'settings/EXPORT_ADD_ON_TRANSLATIONS_ERROR';
export const IMPORT_ADD_ON_TRANSLATIONS = 'settings/IMPORT_ADD_ON_TRANSLATIONS';
export const IMPORT_ADD_ON_TRANSLATIONS_ERROR = 'settings/IMPORT_ADD_ON_TRANSLATIONS_ERROR';

// Add-ons

export const ADD_ON_OAUTH_AUTHORIZATION_CODE_URL_SUCCESS =
    'settings/ADD_ON_OAUTH_AUTHORIZATION_CODE_URL_SUCCESS';
export const FETCH_ADD_ON_OAUTH_AUTHORIZATION_CODE_URL =
    'settings/FETCH_ADD_ON_OAUTH_AUTHORIZATION_CODE_URL';
export const DELETE_ADDON = 'settings/DELETE_ADDON';
export const DELETE_ADDON_SUCCESS = 'settings/DELETE_ADDON_SUCCESS';
export const DELETE_ADDON_ERROR = 'settings/DELETE_ADDON_ERROR';
export const POST_ADD_ON = 'settings/POST_ADD_ON';
export const POST_ADD_ON_SUCCESS = 'settings/POST_ADD_ON_SUCCESS';
export const POST_ADD_ON_ERROR = 'settings/POST_ADD_ON_ERROR';
export const UPDATE_ADD_ON = 'settings/UPDATE_ADD_ON';
export const UPDATE_ADD_ON_SUCCESS = 'settings/UPDATE_ADD_ON_SUCCESS';
export const UPDATE_ADD_ON_ERROR = 'settings/UPDATE_ADD_ON_ERROR';

export const OPEN_ADDON_DETAIL_DRAWER = 'settings/OPEN_ADDON_DETAIL_DRAWER';
export const CLOSE_ADDON_DETAIL_DRAWER = 'settings/CLOSE_ADDON_DETAIL_DRAWER';

// GDAddons Script
export const LOAD_ARTICLES_PICKER_SCRIPT = 'setting/LOAD_ARTICLES_PICKER_SCRIPT';
export const LOAD_ARTICLES_PICKER_SCRIPT_SUCCESS = 'settings/LOAD_ARTICLES_PICKER_SCRIPT_SUCCESS';

// Audience
export const RESET_FACTS_APPLICATION = 'settings/RESET_FACTS_APPLICATION';
export const RESET_FACTS_APPLICATION_ERROR = 'settings/RESET_FACTS_APPLICATION_ERROR';
export const RESET_FACTS_FOR_USER = 'settings/RESET_FACTS_FOR_USER';
export const RESET_FACTS_FOR_USER_ERROR = 'settings/RESET_FACTS_FOR_USER_ERROR';

// Confusion - Guide generation
export const POST_GUIDE_GENERATION = 'settings/POST_GUIDE_GENERATION';
export const POST_GUIDE_GENERATION_SUCCESS = 'settings/POST_GUIDE_GENERATION_SUCCESS';
export const POST_GUIDE_GENERATION_ERROR = 'settings/POST_GUIDE_GENERATION_ERROR';

export const POST_DUPLICATE_APPLICATION = 'settings/POST_DUPLICATE_APPLICATION';
export const POST_DUPLICATE_APPLICATION_SUCCESS = 'settings/POST_DUPLICATE_APPLICATION_SUCCESS';
export const POST_DUPLICATE_APPLICATION_ERROR = 'settings/POST_DUPLICATE_APPLICATION_ERROR';

export const EGG_SERVING_PIPELINE = 'EGGServingPipeline';
